var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Social Media Icons",
    id: "Social_Media_Icons",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: #ebeff1;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: #00b241;\r\n            }\r\n\r\n            .cls-3 {\r\n                fill: #fff;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.66,254.75c-1.65,137.65-115,249.11-252.61,248.6a250.65,250.65,0,0,1-106.42-24l-46.44,18.89L70.81,511A13,13,0,0,1,53,497.16l4.64-33.57,6.74-48.76C15.92,358-7.68,279.3,10.38,195.6c19.92-92.33,91-165.79,182.8-188C360.46-32.86,509.58,93.84,507.66,254.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.63,255C459.29,367.06,367,457.8,255,457.39a204.07,204.07,0,0,1-86.65-19.53L130.5,453.24,105,463.64a10.62,10.62,0,0,1-14.52-11.29L94.21,425l5.49-39.71C60.26,339,41,275,55.75,206.83,72,131.65,129.84,71.83,204.59,53.75,340.78,20.81,462.19,124,460.63,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.11,210s18.4,63.29,81.6,109.19c44.65,32.42,72,37.13,80.37,37.44C312,356.85,343.22,358,361,338c3.53-4,9.12-14.5,10.37-27a11.55,11.55,0,0,0-6.7-11.59l-42-19.31a11.6,11.6,0,0,0-13.32,2.62l-17.76,19a11.58,11.58,0,0,1-12.65,2.9c-15.3-5.92-50.59-23.43-75-65.48a11.63,11.63,0,0,1,.59-12.59l12-16.86a11.58,11.58,0,0,0,1.25-11.24L198.64,153a25.87,25.87,0,0,0-9.27-7c-10.45-4.6-20.53-.29-23,.77-9.89,4.23-14.73,12.3-17.64,17.31C137.92,182.66,140,201.52,143.11,210Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.5e747de6bf136122e10e9b1bbcc88141.svg";
export { ForwardRef as ReactComponent };